import RAPIER from '@dimforge/rapier3d-compat';
import {
  CharacterBehavior,
  ColorCycleBehavior,
  ColorOnClickBehavior,
  DestroyOnDeath,
  FlammableBehavior,
  HealthBehavior,
  ObjectPickupBehavior,
  PlayerControlsBehavior,
  PlayerLifecycleBehavior,
  RandomCharacterMeshBehavior,
  RandomScaleBehavior,
  RandomWalkBehavior,
  RapierSystemBehavior,
  RotationBehavior,
  SpawnerBehavior,
  TemporaryBehavior,
  TransformBehavior,
  world,
} from "./behaviors";

// Initialize RAPIER (required for compat version)
await RAPIER.init();

console.log('RAPIER physics world initialized');

world.registerBehavior(RapierSystemBehavior); // Register physics system first
world.registerBehavior(TransformBehavior); // Register transform behavior (now includes rigidbody functionality)
world.registerBehavior(RotationBehavior);
world.registerBehavior(ColorCycleBehavior);
world.registerBehavior(ColorOnClickBehavior);
world.registerBehavior(CharacterBehavior);
world.registerBehavior(RandomWalkBehavior);
world.registerBehavior(HealthBehavior);
world.registerBehavior(DestroyOnDeath);
//world.registerBehavior(FlammableBehavior);
world.registerBehavior(SpawnerBehavior);
world.registerBehavior(RandomScaleBehavior);
world.registerBehavior(RandomCharacterMeshBehavior);
world.registerBehavior(ObjectPickupBehavior);
world.registerBehavior(PlayerControlsBehavior);
world.registerBehavior(PlayerLifecycleBehavior);
world.registerBehavior(TemporaryBehavior);

world.startObserving(document.body);
